import EcomPanel from './EcomPanel';
import LeadGenPanel from './LeadGenPanel';

/**
 * Elige el layout según `brand.vertical`. Comparte la vista entre admin
 * (selector de marca) y cliente (marca fija del usuario): ambos pasan el
 * payload ya cargado + el summary de comparación.
 */
export default function PanelBody({ data, previousSummary }) {
  if (data?.brand?.vertical === 'ecommerce') {
    return <EcomPanel data={data} previousSummary={previousSummary} />;
  }
  return <LeadGenPanel data={data} />;
}
